import { Component, HostBinding, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DashboardUtils } from '../../utils/dashboard-util';
import { MissingAgencyDashboardStore } from '../../service/missing-agency-dashboard.store';
import { PredefinedSearchService } from '../../service/predefined-search.service';

@Component({
  selector: 'pioneer-missing-agency',
  templateUrl: './missing-agency.component.html'
})
export class MissingAgencyComponent implements OnInit {
  private readonly defaultClasses = 'card collapse';

  @HostBinding('id') id = 'card-2';
  @HostBinding('attr.data-se-id') dataSeId = 'missingAgencyCard';
  @HostBinding('class') classes = this.defaultClasses;

  constructor(
    private missingAgencyStore: MissingAgencyDashboardStore,
    private predefinedSearchService: PredefinedSearchService
  ) {}

  ngOnInit(): void {

    const obs1 = this.missingAgencyStore.cardStateCssClass().map((newClass: string) => {
      return this.defaultClasses + ' ' + newClass;
    });

    const combined = Observable.combineLatest(
      obs1,
      this.missingAgencyStore.showCard()
    );

    combined.subscribe( (fromCombined: [string, boolean]) => {
      const [classes, show] = fromCombined;
      if (show) {
        this.classes = `${classes} show`;
      } else {
        this.classes = classes;
      }
    });

  }

  get missingAgencyTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
  }

  missingAgencyPredefinedSearch(): void {
    this.predefinedSearchService.missingAgencySearch();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/dashboard/missing-agency/missing-agency.component.ts